import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../../shared/services/security/auth.service';
@Injectable()
export class TestABGuard implements CanActivate {

    constructor(
        private router: Router,
        private authService: AuthService
      ) {
      }

    canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        if (this.authService.isTestAB()) {
          return true;
        }
    
        this.router.navigate(['/leads']);
        return false;
      }

}